import { render, staticRenderFns } from "./SearchForProduct.vue?vue&type=template&id=7bd64423&scoped=true&"
import script from "./SearchForProduct.vue?vue&type=script&lang=js&"
export * from "./SearchForProduct.vue?vue&type=script&lang=js&"
import style0 from "./SearchForProduct.vue?vue&type=style&index=0&id=7bd64423&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd64423",
  null
  
)

export default component.exports